export default __webpack_public_path__ + "static/media/rocka1.6 ratio.b15aa56c.png";